// @flow
import React from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import LetterViewer from 'containers/letter/LetterViewer';
import { type Match } from 'react-router-dom';
import LetterCommentsContainer from 'containers/letter/LetterCommentsContainer';
import LetterSequencesContainer from 'containers/letter/LetterSequencesContainer';
import PlainTemplate from 'components/common/PlainTemplate';
import PageTemplate from 'components/base/PageTemplate';

type Props = {
  match: Match,
};

const Letter = ({ match }: Props) => {
  const { username, urlSlug } = match.params;

  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <PlainTemplate>
        <LetterViewer username={username} urlSlug={decodeURI(urlSlug || '')} />
        <LetterCommentsContainer />
      </PlainTemplate>
      <LetterSequencesContainer username={username || ''} />
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Letter;



// WEBPACK FOOTER //
// ./src/pages/Letter.js